import { Link } from "react-router-dom";
import { LockKey, ArrowRight } from "@phosphor-icons/react";
import { Page } from "@/components/Bits";
import { useModules } from "@/context/ModulesContext";

// Blocks a ledger page when its module is switched off for the active organisation.
export default function ModuleGate({ moduleKey, children }) {
  const { modules, labels, tenantId, loading } = useModules();

  if (loading) {
    return <Page><span className="font-mono text-navy/70 text-sm tracking-widest">LOADING…</span></Page>;
  }
  // Only block when we have an active org and the module is explicitly off.
  if (tenantId && modules && !modules[moduleKey]) {
    return (
      <Page>
        <div className="max-w-lg mx-auto mt-10 card-surface p-8 text-center" data-testid={`module-disabled-${moduleKey}`}>
          <span className="w-14 h-14 rounded-2xl bg-navy/[0.06] flex items-center justify-center mx-auto mb-4">
            <LockKey size={26} weight="fill" className="text-navy" />
          </span>
          <h2 className="font-heading font-black text-navy text-2xl tracking-tight">
            {labels[moduleKey] || "This module"} isn't switched on
          </h2>
          <p className="text-navy/70 text-sm mt-2">
            This ledger is switched off for this organisation. Switch it on in Settings → Modules to start working here.
          </p>
          <Link to="/settings?tab=modules" data-testid={`module-disabled-cta-${moduleKey}`}
            className="inline-flex items-center gap-2 mt-5 text-white px-5 py-2.5 rounded-lg text-sm font-semibold hover:bg-navy transition-colors" style={{ background: "#F37A24" }}>
            Go to Modules <ArrowRight size={15} weight="bold" />
          </Link>
        </div>
      </Page>
    );
  }
  return children;
}
